import { render, staticRenderFns } from "./ImgAallery.vue?vue&type=template&id=0b64bf6a&scoped=true"
import script from "./ImgAallery.vue?vue&type=script&lang=js"
export * from "./ImgAallery.vue?vue&type=script&lang=js"
import style0 from "./ImgAallery.vue?vue&type=style&index=0&id=0b64bf6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64bf6a",
  null
  
)

export default component.exports